import { useReducer } from "react";
import jobActions from "./jobActions";
import jobReducer from "./jobReducer";


export default function useJob() {
  const [job, jobDispatch] = useReducer(jobReducer, {});
  const { getDetails, updateSiteContact, updateStreetView, updateRa } = jobActions(jobDispatch);

  return {
    response: job,
    getDetails,
    updateSiteContact,
    updateStreetView,
    updateRa
  };
}
